// @flow

import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { translate } from '../../helpers/global'

type Props = {
  globalGetLanguages: string,
  dropdownId?: string
}

const DropdownTalentMgMobile = ({ globalGetLanguages, dropdownId = "talent-mg-drop" }: Props) => {
  // Define content for each section (simplified for mobile)
  const contentSections = {
    solutions: [
      { to: '/nextgen-assessment-center?utm_content=talent-management', text: 'NextGen Assessment Center' },
      { to: '/talent-management/internal-mobility', text: 'Internal Mobility' },
      { to: '/talent-management/talent-mapping', text: 'Talent Mapping' },
      { to: '/talent-management/succession-planning', text: 'Succession Planning' },
      { to: '/talent-management/high-potential-identification', text: 'High Potential Identification' },
    ]
  }

  return (
    <div id={dropdownId} className="dropdown-for hide">
      <div>
        <a href="#" className="a-for">
          <span>Solutions & Use Cases</span>
          <i className="fas fa-angle-down" />
        </a>
        <div style={{display: 'none'}}>
          {contentSections.solutions.map((link, index) => (
            <Link key={index} to={link.to}>{link.text} <i className="fas fa-arrow-right"></i></Link>
          ))}
        </div>
      </div>
      <hr/>
    </div>
  )
}

export default DropdownTalentMgMobile